import { useEffect, useState } from "react";
import { api } from '../api';
import { useAuth } from "../context/AuthContext";

const UserManagement = () => {
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState({ username: "", password: "", role: "user" });
  const [editingId, setEditingId] = useState(null);
  const [viewingUser, setViewingUser] = useState(null);
  const [popupMessage, setPopupMessage] = useState("");
   const { user } = useAuth();

  const fetchUsers = async () => {
    if (!user) return;
    try {
      const data = await api.getUsers();
      setUsers(data);
    } catch (err) {
      console.error("Failed to load users:", err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingId) {
        await api.updateUser(editingId, form);
      } else {
        await api.addUser(form);
      }
      setForm({ username: "", password: "", role: "user" });
      setEditingId(null);
      fetchUsers();
    } catch (err) {
      console.error("Error saving user:", err);
      setPopupMessage(err.message);
    }
  };

  const handleEdit = (user) => {
    setForm({ username: user.username, password: "", role: user.role });
    setEditingId(user.id);
  };

  const handleDelete = async (id) => {
    try {
      await api.deleteUser(id);
      fetchUsers();
    } catch (err) {
      console.error("Error deleting user:", err);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);


  const taupeColor = "#A89F91";
  const darkText = "#3C3B3F";
  const buttonBg = "#BFA96B";
  const buttonHover = "#A1893E";

  return (
    <div className="p-6 bg-[#F4F1EE] min-h-screen text-[#3C3B3F]">
      <h2 className="text-2xl font-bold mb-6">User Management</h2>

      {/* Form */}
      <form onSubmit={handleSubmit} className="mb-6 flex flex-wrap items-center gap-4">
        <input
          className="border border-[#A89F91] p-2 rounded bg-white text-[#3C3B3F]"
          style={{
            borderColor: taupeColor,
            backgroundColor: "#fff",
            color: darkText,
          }}
          type="text"
          placeholder="Username"
          value={form.username}
          onChange={(e) => setForm({ ...form, username: e.target.value })}
          required

        />
        <input
          className="border border-[#A89F91] p-2 rounded bg-white text-[#3C3B3F]"
          style={{
            borderColor: taupeColor,
            backgroundColor: "#fff",
            color: darkText,
          }}
          type="password"
          placeholder="Password"
          value={form.password}
          onChange={(e) => setForm({ ...form, password: e.target.value })}
          required={!editingId}
        />
        <input
          className="border border-[#A89F91] p-2 rounded bg-white text-[#3C3B3F]"
          style={{
            borderColor: taupeColor,
            backgroundColor: "#fff",
            color: darkText,
          }}
          type="text"
          placeholder="SubType"
          value={form.subType || ""}
          onChange={(e) => setForm({ ...form, subType: e.target.value })}
        />
        <select
          className="border border-[#A89F91] p-2 rounded bg-white text-[#3C3B3F]"
          style={{
            borderColor: taupeColor,
            backgroundColor: "",
            color: darkText,
          }}
          value={form.role}
          onChange={(e) => setForm({ ...form, role: e.target.value })}
        >
          <option value="user">User</option>
          <option value="admin">Admin</option>
        </select>
        <button
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          style={{
            backgroundColor: buttonBg,
            color: darkText,
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = buttonHover;
            e.currentTarget.style.color = "#fff";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = buttonBg;
            e.currentTarget.style.color = darkText;
          }}
          type="submit"
        >
          {editingId ? "Update" : "Add"} User
        </button>
      </form>

      {/* Table */}
      <div className="overflow-x-auto">
        <table className="w-full border border-[#A89F91] text-sm">
          <thead className="bg-[#E8E3DD] text-[#3C3B3F]">
            <tr>
              <th className="p-3 border border-[#A89F91] text-left">Username</th>
              <th className="p-3 border border-[#A89F91] text-left">Role</th>
              <th className="p-3 border border-[#A89F91] text-left">SubType</th>
              <th className="p-3 border border-[#A89F91] text-left">Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user.id} className="hover:bg-[#f0ebe6] transition-all">
                <td className="p-3 border border-[#A89F91]">{user.username}</td>
                <td className="p-3 border border-[#A89F91] capitalize">{user.role}</td>
                <td className="p-3 border border-[#A89F91]">{user.subType || 'N/A'}</td>
                <td className="p-3 border border-[#A89F91] space-x-3">
                  <button onClick={() => setViewingUser(user)} className="text-blue-600 hover:underline">View</button>
                  <button onClick={() => handleEdit(user)} className="text-green-600 hover:underline">Edit</button>
                  <button onClick={() => handleDelete(user.id)} className="text-red-600 hover:underline">Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* View Modal */}
      {viewingUser && (
        <div className="mt-6 bg-white border border-[#A89F91] p-4 rounded shadow text-[#3C3B3F] max-w-md">
          <h3 className="text-lg font-bold mb-3">User Details</h3>
          <p className="mb-1"><strong>ID:</strong> {viewingUser.id}</p>
          <p className="mb-1"><strong>Username:</strong> {viewingUser.username}</p>
          <p className="mb-1"><strong>Role:</strong> {viewingUser.role}</p>
          <button
            onClick={() => setViewingUser(null)}
            className="mt-4 px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
          >
            Close
          </button>
        </div>
      )}

      {/* Popup Message */}
      {popupMessage && (
        <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded shadow-md w-80 text-center text-[#3C3B3F]">
            <h2 className="text-lg font-bold mb-4 text-red-600">Error</h2>
            <p>{popupMessage}</p>
            <button
              className="mt-4 px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
              onClick={() => setPopupMessage("")}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserManagement;
